import { useMemo } from "react";

/**
 * HeaderStatus
 */

type Props = {
  status: number | null;
};

export const HeaderStatus = ({
  status
}: Props) => {
  const tagColor = useMemo(() => {
    if (status === null) return '';
    if (status === 0) {
      return 'bg-red-100 text-red-700 border border-red-300';
    }
    if (status === 1) {
      return 'bg-yellow-100 text-yellow-700 border border-yellow-300';
    }
    if (status === 2) {
      return 'bg-orange-200 text-orange-700 border border-orange-300';
    }
    if (status === 3) {
      return 'bg-orange-300 text-orange-700 border border-orange-700';
    }
    return 'bg-green-100 text-green-700 border border-green-300';
  }, [
    status,
  ]);

  const tagText = useMemo(() => {
    if (status === null) return '';
    if (status === 0) {
      return 'FUNCIONÁRIO INATIVO';
    }
    if (status === 1) {
      return 'FUNCIONÁRIO AFASTADO';
    }
    if (status === 2) {
      return 'FUNCIONÁRIO EM AVISO PRÉVIO';
    }
    if (status === 3) {
      return 'FUNCIONÁRIO AVISO PRÉVIO ENCERRADO';
    }
    return 'FUNCIONÁRIO ATIVO';
  }, [
    status,
  ]);

  return (
    <div className="flex items-center justify-center w-[25rem]">
      <div className={`px-4 py-2 rounded-lg font-semibold text-sm ${tagColor}`}>
        {tagText}
      </div>
    </div>
  );
}